import PrescriptionTable from "./PrescriptionTable";

export default PrescriptionTable;